import React, { PropsWithChildren, FC, memo } from 'react';

interface PlayerIndexFormatProps {
  index: number;
  label?: string;
}

const PlayerIndexFormatComponent: FC<PropsWithChildren<PlayerIndexFormatProps>> = ({
  index,
  label,
}) => {
  if (typeof index !== 'number') {
    return null;
  }

  if (label) {
    return <>{`Player ${index + 1} ${label}`}</>;
  }

  return <>{`Player ${index + 1}`}</>;
};

export const PlayerIndexFormat = memo(PlayerIndexFormatComponent);
